/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/en_US';
import DatePicker from './date-picker/en_US';
import Pagination from './pagination/en_US';
import TimePicker from './time-picker/en_US';

export default {
  locale: 'ne-np',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'à¤«à¤¿à¤²à¥à¤à¤° à¤®à¥à¤¨à¥',
    filterConfirm: 'à¤¹à¥',
    filterReset: 'à¤°à¥à¤¸à¥à¤',
    selectAll: 'à¤¸à¤¬à¥ à¤à¤¾à¤¨à¥à¤¨à¥à¥à¤¹à¥à¤¸à¥',
    selectInvert: 'à¤à¤¨à¥à¤ à¤à¤²à¥à¤à¤¾à¤à¤¨à¥à¤¹à¥à¤¸'
  },
  Modal: {
    okText: 'à¤¹à¥',
    cancelText: 'à¤¹à¥à¤à¤¨',
    justOkText: 'à¤¹à¥'
  },
  Popconfirm: {
    okText: 'à¤¹à¥',
    cancelText: 'à¤¹à¥à¤à¤¨'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'à¤¯à¤¹à¤¾à¤ à¤à¥à¤à¥à¤¨à¥à¤¹à¥à¤¸à¥',
    itemUnit: 'à¤µà¤¸à¥à¤¤à¥',
    itemsUnit: 'à¤µà¤¸à¥à¤¤à¥à¤¹à¤°à¥'
  },
  Upload: {
    uploading: 'à¤à¤ªà¤²à¥à¤¡ à¤à¤°à¥à¤¦à¥...',
    removeFile: 'à¤«à¤¾à¤à¤² à¤¹à¤à¤¾à¤à¤¨à¥à¤¹à¥à¤¸à¥',
    uploadError: 'à¤à¤ªà¥à¤²à¥à¤¡à¤®à¤¾ à¤¸à¤®à¤¸à¥à¤¯à¤¾ à¤­à¤¯à¥',
    previewFile: 'à¤«à¤¾à¤à¤² à¤ªà¥à¤°à¥à¤µà¤¾à¤µà¤²à¥à¤à¤¨ à¤à¤°à¥à¤¨à¥à¤¹à¥à¤¸à¥'
  },
  Empty: {
    description: 'à¤¡à¤¾à¤à¤¾ à¤à¥à¤¨'
  }
};
